// Opciones base para Order By
export const BASE_ORDER_BY_OPTIONS = [
  { value: 'Case', label: 'Case' }
];